import axios from "axios";
import qs from "qs";
import store from "store/store";

import { actions } from "store/authRedux/actions";
import { actions as commonActions } from "store/commonRedux/actions";
import { GetUserByRefresh, LogoutBlacklist } from "services/account";

import { toast } from "react-toastify";
import { getUserChannelId } from "./_helpers";

const URLBlacklist = ["/account/auth/refresh"];

// logout user from server and local store
const logoutUser = (refreshToken) => {
  LogoutBlacklist(refreshToken);
  store.dispatch(actions.logout());
  store.dispatch(commonActions.resetUserVariables());
};

// create axios instance
const Api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
  paramsSerializer: (params) => {
    return qs.stringify(params, {
      arrayFormat: "repeat",
    });
  },
});

// API Request interceptor
Api.interceptors.request.use(
  (config) => {
    const access_token = store.getState().auth.access;

    // add access token to headers if exists
    if (access_token) {
      config.headers["Authorization"] = `Bearer ${access_token}`;
      config.headers[`Accept-Language`] = "fa";
    }

    config.params = config.params ? config.params : {};
    // add coordinates user for fetching location specific data
    const coordinates = store.getState().common.tempAddress;
    const uuid = store.getState().common.uuid;
    const channel = store.getState().common.channelId;

    if (uuid) {
      config.params["uuid"] = uuid;
    }

    if (channel) {
      config.params["channel"] = getUserChannelId(channel);
    }

    if (coordinates) {
      config.params["latitude"] = coordinates.latitude;
      config.params["longitude"] = coordinates.longitude;
    }

    return config;
  },
  (error) => {
    Promise.reject(error);
  },
);

// API respone interceptor
Api.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    // check if network error
    if (!error.response || error.message == "Network Error") {
      toast.error("خطا در اتصال به اینترنت");
    } else if (error.response.status === 401) {
      return new Promise(async function (resolve, reject) {
        const refreshToken = store.getState().auth.refresh;

        try {
          // check if user is logged in
          if (
            refreshToken &&
            !URLBlacklist.find((url) => error.config.url.includes(url))
          ) {
            // fetch a new access token
            await GetUserByRefresh(refreshToken).then((res) => {
              // replace new access token & execute api request again
              store.dispatch(actions.refresh(res.access));
              error.config.headers["Authorization"] = `Bearer ${res.access}`;
              return Api.request(error.config);
            });
            resolve();
          } else {
            //   logging out user
            logoutUser();
            resolve();
          }
        } catch (err) {
          //   logging out user
          logoutUser();
          reject();
        }
      });
    }

    // handle 404 error
    else if (error.response.status === 404) {
      toast.error("اطلاعات مورد نظر یافت نشد");
    }

    // handle 429 error
    else if (error.response.status === 429) {
      toast.error(
        "تعداد درخواست هاش ما از حد مجاز گذشته است لطفا بعد از یک دقیقه دوباره تلاش کنید",
      );
    }

    // handle 409 error
    else if (error.response.status === 409) {
      toast.error(
        error.response?.data?.message ||
          "خطا در انجام عملیات، لطفا دوباره تلاش کنید.",
      );
    }

    // handle 500 error
    else if (error.response.status === 500) {
      toast.error("خطایی در سرور رخ داده است! لطفا بعدا تلاش کنید");
    }

    // handle 508 error
    else if (error.response.status === 508) {
      toast.error("خطا در اتصال به سرور");
    }

    return Promise.reject(error);
  },
);

export default Api;
